var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage04Layer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 400",
    style: {
      enableBackground: "new 0 0 500 400"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#00cbd8}.st1{fill:#02cbd8}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72,
    cy: 8.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72,
    cy: 41.3,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72,
    cy: 73.9,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72,
    cy: 106.5,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72,
    cy: 139.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72,
    cy: 171.6,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72,
    cy: 204.2,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.4 8.7c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C97.7 5.9 96.4 7.2 96.4 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.4 41.3c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C97.7 38.5 96.4 39.8 96.4 41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.4 73.9c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8.0-1.6-1.3-2.8-2.8-2.8C97.7 71.1 96.4 72.3 96.4 73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.4 106.5c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8.0-1.6-1.3-2.8-2.8-2.8C97.7 103.6 96.4 104.9 96.4 106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.4 139.1c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C97.7 136.2 96.4 137.5 96.4 139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.4 171.6c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C97.7 168.8 96.4 170.1 96.4 171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.4 204.2c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C97.7 201.4 96.4 202.7 96.4 204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.6 8.7c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C124.8 5.9 123.6 7.2 123.6 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.6 41.3c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C124.8 38.5 123.6 39.8 123.6 41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.6 73.9c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8.0-1.6-1.3-2.8-2.8-2.8C124.8 71.1 123.6 72.3 123.6 73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.6 106.5c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8.0-1.6-1.3-2.8-2.8-2.8C124.8 103.6 123.6 104.9 123.6 106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.6 139.1c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C124.8 136.2 123.6 137.5 123.6 139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.6 171.6c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C124.8 168.8 123.6 170.1 123.6 171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.6 204.2c0 1.6 1.3 2.8 2.8 2.8 1.6.0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8C124.8 201.4 123.6 202.7 123.6 204.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 153.6,
    cy: 8.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 153.6,
    cy: 41.3,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 153.6,
    cy: 73.9,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 153.6,
    cy: 106.5,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 153.6,
    cy: 139.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 153.6,
    cy: 171.6,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 153.6,
    cy: 204.2,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178 8.7c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C179.2 5.9 178 7.2 178 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178 41.3c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C179.2 38.5 178 39.8 178 41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178 73.9c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8c0-1.6-1.3-2.8-2.8-2.8C179.2 71.1 178 72.3 178 73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178 106.5c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8c0-1.6-1.3-2.8-2.8-2.8C179.2 103.6 178 104.9 178 106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178 139.1c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C179.2 136.2 178 137.5 178 139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178 171.6c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C179.2 168.8 178 170.1 178 171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178 204.2c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C179.2 201.4 178 202.7 178 204.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 208,
    cy: 8.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 208,
    cy: 41.3,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 208,
    cy: 73.9,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 208,
    cy: 106.5,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 208,
    cy: 139.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 208,
    cy: 171.6,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 208,
    cy: 204.2,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 235.2,
    cy: 8.7,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 235.2,
    cy: 41.3,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 235.2,
    cy: 73.9,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 235.2,
    cy: 106.5,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 235.2,
    cy: 139.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 235.2,
    cy: 171.6,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 235.2,
    cy: 204.2,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5 8.7c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C260.8 5.9 259.5 7.2 259.5 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5 41.3c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C260.8 38.5 259.5 39.8 259.5 41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5 73.9c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8c0-1.6-1.3-2.8-2.8-2.8C260.8 71.1 259.5 72.3 259.5 73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5 106.5c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8c0-1.6-1.3-2.8-2.8-2.8C260.8 103.6 259.5 104.9 259.5 106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5 139.1c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C260.8 136.2 259.5 137.5 259.5 139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5 171.6c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C260.8 168.8 259.5 170.1 259.5 171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5 204.2c0 1.6 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8C260.8 201.4 259.5 202.7 259.5 204.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.8 17.4H383.5V6.1H372.8V17.4H361.5V28.1H372.8V39.4H383.5V28.1H394.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.8 103.5H383.5V92.2H372.8V103.5H361.5V114.2H372.8V125.5H383.5V114.2H394.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467.3 17.4H456V6.1H445.3V17.4H434V28.1H445.3V39.4H456V28.1H467.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467.3 103.5H456V92.2H445.3V103.5H434V114.2H445.3V125.5H456V114.2H467.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage04Layer2);
export default __webpack_public_path__ + "static/media/image-04-layer-2.b7e28f2645da25af2d7334356bd88618.svg";
export { ForwardRef as ReactComponent };